import api from 'api';
import config from 'config';
import type { TalkBeforeCancelForm } from 'redux/modules/subscriptions.types';

const subscriptionApi = {
  saveTalkBeforeCancelForm: async (payload: TalkBeforeCancelForm): Promise<{ ok: boolean }> => {
    const baseUrl = config.isProduction ? 'https://actions.memory.ai' : 'http://localhost:9000';
    const url = `${baseUrl}/.netlify/functions/timely_cancel_subscription_callback`;
    const response = await fetch(url, { method: 'post', body: JSON.stringify(payload) });
    return response.json();
  },
  cancelSubscriptionAndRedirect: (): Promise<unknown> => {
    return api.delete(`settings/subscription.json`);
  },
};

export default subscriptionApi;
